import React, {useEffect} from "react";
import {Redirect, Route, Switch,} from "react-router-dom";
import classnames from "classnames";
import {Card, CardContent, Typography} from '@material-ui/core'

//icons
// styles
import useStyles from "./styles";

// components
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";

// pages
import Dashboard from "../../pages/dashboard/Dashboard";
import JobDashboard from "../../pages/jobdashboard/JobDashboard";
import Offers from "../../pages/offers/Offers";
import Error from "../../pages/error/Error"

// context
import {useLayoutState} from "../../context/LayoutContext";
import {Footer} from "../Footer/Footer";
import {load_all_jobs, logout, resetServerError} from "../../datamanagement/actions";
import {connect} from "react-redux";
import {CookieSnackbar} from "../CookieSnackbar/CookieSnackbar";

function Layout(props) {
    var classes = useStyles();

    // global
    var layoutState = useLayoutState();

    const loadingError = !!props.profile_error;
    useEffect(() => {
        props.load_all_jobs()
    }, []);

    return (

        <div className={classes.root}>
            <Header history={props.history}/>
            <Sidebar/>
            <div
                className={classnames(classes.content, {
                    [classes.contentShift]: layoutState.isSidebarOpened,
                })}
            >
                <div className={classes.fakeToolbar}/>
                <div className={classes.subContent}>


                    {loadingError ? <div className={classes.subContent}>
                            <Card>
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="h2">
                                        Error Encountered
                                    </Typography>
                                    {(props.profile_error?.payload) ?
                                        <Typography variant="body2" color="textSecondary" component="p">
                                            {props.profile_error.payload}
                                        </Typography> : <br/>
                                    }
                                </CardContent>
                            </Card>
                        </div> :


                        <Switch>
                            <Route path="/app/dashboard" component={Dashboard}/>
                            <Route path="/app/offers" component={Offers}/>
                            <Route path="/app/job/:id" component={JobDashboard}/>
                            <Redirect to='/app/404' component={Error}/>
                        </Switch>}
                </div>
                <Footer/>
                <CookieSnackbar/>
            </div>
        </div>


    );
}

const mapStateToProps = ({profile_error}) => {
    return {profile_error};
}


const mapDispatchToProps = (dispatch, {history}) => {
    return {
        logout: (history) => logout(dispatch, history),
        resetServerError: () => resetServerError(dispatch),
        load_all_jobs: () => load_all_jobs(dispatch, history),

    };
}


export default connect(mapStateToProps, mapDispatchToProps)(Layout);
